export function getDoctorDefaultImg(gender?: number) {
  return gender === 1 ? 
  "/images/doctor_female_v2.svg" : 
  "/images/doctor_male_v2.svg";
}

export function getClinicDefaultimg() {
  return "/images/clinic-placeholder.png";
}
